/* convert-test:why-birdman variant-b START */
/**
 * Convert — test "why-birdman".
 *
 * 1. Trigger manual (location 1004160308, "Trigger - Why Birdman")
 *    El acordeón vive muy abajo en la PDP, así que el experimento no se activa
 *    al cargar sino cuando el usuario scrollea hasta los dropdowns.
 *
 *    Se observa el CONTENEDOR .main-product-accordions, no la tab del test:
 *    la tab está en display:none para la variante A, y un elemento oculto nunca
 *    intersecta. Si observáramos la tab, la variante A no se activaría nunca y
 *    el experimento se quedaría sin grupo de control.
 *
 * 2. Goal (1004126062, "Goal - Click Acordion")
 *    Se dispara al ABRIR la tab. El cierre no cuenta.
 *
 * Ambos disparan una sola vez por carga de página, para no mandar activaciones
 * ni conversiones duplicadas a Convert.
 *
 * Si la tab no se renderizó (producto fuera del test, ej. merch), el script no
 * hace nada: ese visitante no se mete al experimento.
 */
(function () {
  var LOCATION_ID = '1004160308';
  var GOAL_ID = '1004126062';

  var $accordion = document.querySelector('.why-birdman-accordion');
  if (!$accordion) return;

  window._conv_q = window._conv_q || [];

  /* ---------- 1. Trigger manual al scrollear hasta los dropdowns ---------- */

  var locationSent = false;

  function triggerLocation() {
    if (locationSent) return;
    locationSent = true;

    console.log('Trigger - Why Birdman');

    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: 'triggerLocation',
      params: {
        locationId: LOCATION_ID
      }
    });
  }

  var observer = null;

  function watchContainer() {
    if (locationSent) return;

    // Se vuelve a consultar el DOM en cada intento: al cambiar de variante,
    // product-linking reemplaza el contenedor y la referencia anterior queda
    // apuntando a un nodo desprendido, que nunca intersecta.
    var $current = document.querySelector('.why-birdman-accordion');
    if (!$current) return;

    // Contenedor visible en ambas variantes. El fallback NUNCA debe ser la tab:
    // en la variante A está en display:none, nunca intersecta, y el experimento
    // se quedaría sin grupo de control sin que nada falle a la vista.
    var $container = $current.closest('.main-product-accordions') || $current.parentElement;

    if (!$container || !('IntersectionObserver' in window)) {
      // Sin contenedor o sin IntersectionObserver (navegadores viejos): se activa
      // de inmediato. Preferible a dejar a ese visitante fuera del experimento.
      triggerLocation();
      return;
    }

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          triggerLocation();
          observer.disconnect();
          observer = null;
          return;
        }
      }
    });
    observer.observe($container);
  }

  watchContainer();

  // product-linking emite este evento después de reemplazar los elementos
  // (snippets/js-product-linking.liquid). Hay que volver a observar el contenedor nuevo.
  document.addEventListener('update::product_linking', watchContainer);

  /* ---------- 2. Goal: primera apertura de la tab ---------- */

  var goalSent = false;

  function triggerGoal() {
    if (goalSent) return;
    goalSent = true;

    console.log('Goal - Click Acordion');

    window._conv_q = window._conv_q || [];
    window._conv_q.push(['triggerConversion', GOAL_ID]);
  }

  // Delegación en document: sobrevive a cualquier re-render del acordeón
  // (product-linking reemplaza nodos con replaceWith, lo que mata listeners directos).
  document.addEventListener('click', function (event) {
    var $summary = event.target.closest('summary');
    if (!$summary) return;

    if (!$summary.closest('.why-birdman-accordion')) return;

    // En el momento del click el <details> todavía tiene el estado previo:
    // si ya está abierto, este click lo está cerrando y no cuenta como goal.
    if ($summary.parentElement.open) return;

    triggerGoal();
  });
})();
/* convert-test:why-birdman variant-b END */
